import { render, staticRenderFns } from "./ToothBoxes.vue?vue&type=template&id=b4db84b2&"
import script from "./ToothBoxes.vue?vue&type=script&lang=js&"
export * from "./ToothBoxes.vue?vue&type=script&lang=js&"
import style0 from "./ToothBoxes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports